import type { ReactNode } from 'react';

export const symbol_camera_video: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M358-180h244l-25-100H383l-25 100Zm2-160h240q91 0 155.5-64.5T820-560q0-91-64.5-155.5T600-780H360q-91 0-155.5 64.5T140-560q0 91 64.5 155.5T360-340Zm49-149q-29-29-29-71t29-71q29-29 71-29t71 29q29 29 29 71t-29 71q-29 29-71 29t-71-29ZM257-613q12 0 21-9t9-21q0-13-9-21.5t-21-8.5q-13 0-21.5 8.5T227-643q0 12 8.5 21t21.5 9Zm-67 493q-13 0-21.5-8.5T160-150q0-13 8.5-21.5T190-180h107l26-102q-103-14-173-92.5T80-560q0-117 81.5-198.5T360-840h240q117 0 198.5 81.5T880-560q0 107-70 185.5T637-282l26 102h107q13 0 21.5 8.5T800-150q0 13-8.5 21.5T770-120H190Zm403-327q47-47 47-113t-47-113q-47-47-113-47t-113 47q-47 47-47 113t47 113q47 47 113 47t113-47ZM480-560ZM358-180h244-244Z"
		/>
	</svg>
);
